<template>
  <div class="hello">
    <div>
    </div>
  </div>
</template>
<script>
import { initializeApp } from 'firebase/app'
import { getFirestore, collection, getDocs/* query, orderBy, limit, onSnapshot, */ /* doc, deleteDoc */ } from 'firebase/firestore'

// onSnapshot
const firebaseConfig = {
  apiKey: 'AIzaSyAYyrbfJqfLi-4-YK-ZukedZ9QIHW0PBMY',
  authDomain: 'change-url-1c749.firebaseapp.com',
  projectId: 'change-url-1c749',
  storageBucket: 'change-url-1c749.appspot.com',
  messagingSenderId: '726013424830',
  appId: '1:726013424830:web:66972ab00d1bc24d2d5aef'
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

// sloth連動redirect用ページ。GAでview数も取得

export default {
  name: 'MyRedirect',
  props: {
  },

  data: function () {
    return {
    }
  },

  // .eslintrc.jsに以下の設定を追加でindex.htmlの変数を取得できる！
  // globals: {
  // dataLayer: false  // 実行時に追加するグローバル変数.trueだと上書き可能
  // }
  mounted: function () {
    this.getdata_from_firestore()
  },

  methods: {
    async getdata_from_firestore () {
      const querySnapshot = await getDocs(collection(db, 'users'))
      querySnapshot.forEach((doc) => {
        console.log(doc.id, ' => ', doc.data().url)
        const data = doc.data()
        window.dataLayer.push({
          EventCategory: data.category,
          EventAction: data.action,
          EventLabel: data.label,
          event: 'gtmEvent'
        })
        window.location.replace(data.url)
      })
    }
  }
} // export default
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
